import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, MailIcon, LocationIcon, HeartIcon } from './icons/ModernIcons';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="space-y-6"
          >
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">L</span>
              </div>
              <span className="text-xl font-bold">LIMA-Service</span>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Ihr Spezialist für hochwertigen Textildruck im Fränkischen Seenland. Wir bringen Ihre kreativen Ideen professionell auf Textilien.
            </p>
            <div className="flex space-x-4">
              <motion.a
                href="tel:01755525889"
                whileHover={{ scale: 1.1 }}
                className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center hover:bg-blue-700 transition-colors"
              >
                <PhoneIcon className="w-5 h-5" />
              </motion.a>
              <motion.a
                href="mailto:info@lima-service.de"
                whileHover={{ scale: 1.1 }}
                className="w-10 h-10 bg-purple-600 rounded-lg flex items-center justify-center hover:bg-purple-700 transition-colors"
              >
                <MailIcon className="w-5 h-5" />
              </motion.a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="space-y-6"
          >
            <h3 className="text-lg font-bold">Services</h3>
            <ul className="space-y-3 text-gray-400">
              <li className="hover:text-white transition-colors cursor-pointer">FLEX-Folie Druck</li>
              <li className="hover:text-white transition-colors cursor-pointer">Beflockung</li>
              <li className="hover:text-white transition-colors cursor-pointer">DTF-Druck</li>
              <li className="hover:text-white transition-colors cursor-pointer">Lasertransferdruck</li>
              <li className="hover:text-white transition-colors cursor-pointer">Firmenbekleidung</li>
              <li className="hover:text-white transition-colors cursor-pointer">Event-Textilien</li>
              <li className="hover:text-white transition-colors cursor-pointer">Individuelle Beratung</li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="space-y-6"
          >
            <h3 className="text-lg font-bold">Kontakt</h3>
            <div className="space-y-4 text-gray-400">
              <div className="flex items-start space-x-3">
                <LocationIcon className="w-5 h-5 mt-1 text-blue-400" />
                <div>
                  <p>Röttenbacher Straße 5</p>
                  <p>91785 Pleinfeld</p>
                  <p>Deutschland</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <PhoneIcon className="w-5 h-5 text-blue-400" />
                <a href="tel:01755525889" className="hover:text-white transition-colors">
                  01755525889
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <MailIcon className="w-5 h-5 text-blue-400" />
                <a href="mailto:info@lima-service.de" className="hover:text-white transition-colors">
                  info@lima-service.de
                </a>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="border-t border-gray-800 pt-8 text-center"
        >
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 flex items-center space-x-1">
              <span>© {currentYear} LIMA-Service. Gemacht mit</span>
              <HeartIcon className="w-4 h-4 text-red-500" />
              <span>in Pleinfeld</span>
            </p>
            <div className="flex space-x-6 text-sm text-gray-400">
              <a href="#" className="hover:text-white transition-colors">Impressum</a>
              <a href="#" className="hover:text-white transition-colors">Datenschutz</a>
              <a href="#" className="hover:text-white transition-colors">AGB</a>
            </div>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;